import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { concatMap, filter, take } from 'rxjs/operators';
import { ModalidadeService } from '../shared/services/modalidade.service';

@Injectable({
    providedIn: 'root'
})
export class ModalidadeFillerInterceptor implements HttpInterceptor {
    constructor(private modalidadeService: ModalidadeService) {}

    // o endpoint modalidadesHabilitadas pode ser suprimido depois de fazer merge com o gestor AD
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if(!req.url.match(/rest\/front\//)
        || req.url.match(/atribuirModalidade/)
        || req.url.match(/modalidadesHabilitadas/)
        || req.url.match(/todasModalidades/)
        || req.url.match(/mapaRoles/)
        || req.url.match(/cotistas/)
        || req.url.match(/pessoasjuridicas/)) {
            return next.handle(req);
        }

        // este observável abaixo se completa automaticamente por causa do take(1)
        // se não completar, os resolvers param de funcionar (ficam aguardando o observável completar eternamente)
        return this.modalidadeService.modalidade$.pipe(
            filter(mod => !!mod),
            take(1),
            concatMap(modalidade => {
                const httpReq = req.clone({
                    url: req.url.replace('front/', `front/${modalidade}/`)
                });

                return next.handle(httpReq);
            })
        );
    }
}
